import {
  Hand,
  MessageCircle,
  Activity,
  Users,
  BookOpen,
} from "lucide-react";

export const SERVICES = [
  {
    key: "occupational-therapy",
    title: "Occupational Therapy",
    icon: Hand,
    desc: "Building fine motor, sensory processing, and daily-living skills through play-based, structured sessions.",
    tags: ["Fine Motor", "Sensory Integration", "ADL"],
  },
  {
    key: "speech-therapy",
    title: "Speech Therapy",
    icon: MessageCircle,
    desc: "Assessment and intervention for articulation, language delays, fluency, and social communication.",
    tags: ["Articulation", "Language", "Fluency"],
  },
  {
    key: "physiotherapy",
    title: "Physiotherapy",
    icon: Activity,
    desc: "Pediatric physio for gross motor delays, tone management, gait training and post-injury recovery.",
    tags: ["Gross Motor", "Gait", "Tone"],
  },
  {
    key: "child-parent-counselling",
    title: "Child and Parent Counselling",
    icon: Users,
    desc: "Warm, evidence-informed counselling for children and parents — building understanding, coping strategies and stronger family bonds.",
    tags: ["Family", "Coping", "Guidance"],
  },
  {
    key: "special-education",
    title: "Special Education",
    icon: BookOpen,
    desc: "Individualized learning plans for children with learning differences — from remediation to acceleration.",
    tags: ["IEP", "Remediation", "Learning"],
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="scroll-mt-20 py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#0055FF]">
            Our Services
          </div>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0A192F] tracking-tight">
            Five specialised therapies. One integrated team.
          </h2>
          <p className="mt-4 text-[#475569] text-base sm:text-lg max-w-2xl">
            Every therapy plan at SHUNYA is designed collaboratively — so your
            child gets consistent, coordinated care across every discipline.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.key}
                data-testid={`service-card-${s.key}`}
                className="group bg-white border border-[#E2E8F0] rounded-xl p-6 transition-all hover:border-[#0055FF] hover:-translate-y-1 hover:shadow-sm"
              >
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-[#E6F5EE] text-[#0055FF]">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 font-heading text-xl font-semibold text-[#0A192F]">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-[#475569] leading-relaxed">
                  {s.desc}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span
                      key={t}
                      className="inline-flex items-center rounded-full border border-[#E2E8F0] bg-[#F8FAFC] px-2.5 py-1 text-[11px] text-[#475569]"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
